import { useState, useEffect, useRef } from "react";
import { CSSTransition } from 'react-transition-group';




import FilterIcon from "../../assets/images/filter.svg";
import moment from "moment";



const DefaultColumnFilter = ({ name, column: { filterValue, setFilter, preFilteredRows, id } }) => {

    const [filterOpen, setFilterOpen] = useState(false);
    return (
        <div className="">
            {filterOpen ? (

                <>
                    <div className="flex items-center">
                        <img onClick={() => { setFilterOpen(!filterOpen); setFilter('') }} src={FilterIcon} alt="Filter Icon" className="w-4 h-4 mr-1" />
                        <input
                            value={filterValue || ''}
                            onChange={e => {
                                setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
                            }}
                            autoFocus
                            placeholder={`Search ${id}`}
                            style={{
                                width: '100%',
                                padding: '4px',
                                borderRadius: '5px',
                                fontWeight: 'normal'
                            }}
                        />
                    </div>
                </>
            ) : (
                <div className="flex items-center whitespace-nowrap">
                    <span>{name}</span>
                    <img onClick={() => setFilterOpen(!filterOpen)} src={FilterIcon} alt="Filter Icon" className="w-4 h-4 ml-2" />
                </div>
            )}
        </div>
    );
};


const CustomHeader = ({ column }) => {

    const hasFilter = column.hasFilter || false;
    return (
        hasFilter ? <DefaultColumnFilter name={column.title} column={column} /> : <div>{column.title}</div>

    );
};

const DropdownMenu = () => {




    return (
        <div className="relative right-15 top-[10px] w-48 bg-white rounded-md border border-[#3b3b3b] rounded-[5px] shadow-lg z-99999999999 dropdown-menu transition-opacity duration-3000 ease-in-out opacity-100">

            <div className="mt-1 p-2">
                <div className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black">
                    <i className="fas fa-edit"></i>
                    <span className="ml-2">Edit</span>
                </div>
                <div className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black">
                    <i className="fas fa-chart-line"></i>
                    <span className="ml-2">Stats</span>
                </div>

            </div>

        </div>
    );
};
const DropdownLabel = ({ value }) => {
    const [isOpen2, setIsOpen2] = useState(false);

    const dropdownRef = useRef(null);
    const openDropdownRef = useRef(null); // Ref to track the currently open dropdown


    const toggleDropdown = () => {
        if (openDropdownRef.current && openDropdownRef.current !== dropdownRef.current) {
            // Close the currently open dropdown
            openDropdownRef.current.setIsOpen2(false);
        }
        setIsOpen2(!isOpen2);
        if (!isOpen2) {
            openDropdownRef.current = { setIsOpen2, dropdownRef: dropdownRef.current }; // Update the ref to the current dropdown
        } else {
            openDropdownRef.current = null; // Reset if closing the current dropdown
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen2 && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen2(false);
                openDropdownRef.current = null; // Reset the open dropdown ref
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen2]);

    return (
        <div className="rounded-full cursor-pointer text-[#3b3b3b] dropdown-menu border border-[#3b3b3b] p-2 w-10 h-10 text-center" onClick={toggleDropdown} ref={dropdownRef}>
            <i className="fas fa-ellipsis-v"></i>
            <div className="absolute">
                <CSSTransition
                    in={isOpen2}
                    timeout={100}
                    classNames="slide-up"
                    unmountOnExit
                >
                    <DropdownMenu />
                </CSSTransition>
            </div>
        </div>
    );
};




const statusBadge = (value) => {
    // Check if the value is 'Draft' or 'Approved' to set the font color
    const fontColor = (value === 'Draft' || value === 'Approved') ? 'text-customGreen' : 'text-customYellow';

    return (
        <div className={`badge ${fontColor} items-center overflow-hidden whitespace-nowrap text-ellipsis font-bold`}>
            <span>{value}</span>
        </div>
    )
}





const cellRenderer = ({ value }) => {
    return <div className="p">{value}</div>
}


const columns = [
    {
        Header: CustomHeader,
        accessor: 'incident_id',
        title: 'ID',
        Cell: cellRenderer
    },
    {
        Header: CustomHeader,
        accessor: 'title',
        title: 'Risk',
        Cell: cellRenderer

    },
    {

        Header: CustomHeader,
        accessor: 'report_date',
        title: 'Date',
        Cell: ({ value }) => moment(value).format('YYYY-MM-DD')
    },
    {

        Header: CustomHeader,
        accessor: 'location',
        title: 'Location',
        Cell: cellRenderer,
        //hasFilter: true
    },

];



export default columns;
